module.exports = __webpack_public_path__ + "img/note.678b86d7.jpg";